import { useMemo } from 'react';
import { NoteAnimationAction, NoteAnimationData } from '../providers';

const fadeOutActions: NoteAnimationAction[] = ['Move'];
const fadeInActions: NoteAnimationAction[] = [
  'AddNote',
  'NotesMerge',
  'SplitNote'
];

export const useAnimationInfo = (
  animationData?: NoteAnimationData
): { doFadeOutAnimation: boolean; doFadeInAnimation: boolean } =>
  useMemo(
    () => ({
      doFadeOutAnimation: animationData?.action
        ? fadeOutActions.includes(animationData?.action)
        : false,
      doFadeInAnimation: animationData?.action
        ? fadeInActions.includes(animationData?.action)
        : false
    }),
    [animationData?.action]
  );
